import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table} from 'semantic-ui-react';
import {findUserAgency} from '../../../common/util/user';

class Agency extends Component {
  render() {
    const {agencies, order} = this.props;
    const orderAgency = findUserAgency(agencies, order.dealer, order.agency);
    const displayText = orderAgency ? orderAgency.description : order.agency;

    return (<Table.Cell>{displayText}</Table.Cell>);
  }
}

const mapStateToProps = (state) => {
  return {
    'agencies': state.dealer.agencies,
  };
};

export default connect(mapStateToProps)(Agency);
